import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Toast } from 'primeng/toast';

import { GR_TOAST_KEY, GR_TOAST_STYLE_CLASS } from './toast.types';

@Component({
  selector: 'gr-toast',
  imports: [Toast],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: contents;' },
  template: `
    <p-toast
      [key]="key"
      [styleClass]="styleClass"
      [breakpoints]="breakpoints"
      position="top-right"
    />
  `,
})
export class GrToastComponent {
  protected readonly key = GR_TOAST_KEY;
  protected readonly styleClass = GR_TOAST_STYLE_CLASS;

  // Centre the stack on phones, preserving side gutters and capping it at the desktop width.
  protected readonly breakpoints: Record<string, Record<string, string>> = {
    '640px': {
      width: 'min(var(--layout-toast-width), calc(100% - 2 * var(--space-4)))',
      right: 'auto',
      left: '50%',
      transform: 'translateX(-50%)',
    },
  };
}
